import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";

export type KeyCollectionPrayersProps = {
  id: number;
};

export const keyCollectionPrayers: BaseKeyFunction<
  KeyCollectionPrayersProps
> = ({ id }) => ["collection-prayers", id.toString()];
